import React from 'react';
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import {Typography} from "@mui/material";

const RegionRoute = ({label, className}) => {
    return <Typography variant="body1" gutterBottom className={className} style={{fontWeight: 700, maxHeight:32}}>
             {label}
    </Typography>
}

export default
    compose(
        withTranslation())(RegionRoute);